let $_http;

export function init$http($http) {
  $_http = $http;
}

export function get$http($http) {
  return $_http;
}
